import { Map } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'

import { keyBy } from 'utils/immutable'
import * as actions from './actions'

const byId = handleActions({
  [actions.receiveAttachments]: (state, action) => {
    return state.merge(keyBy(action.payload))
  },
  [actions.uploadAttachmentSuccess]: (state, action) => {
    const { attachment } = action.payload
    return state.set(attachment.id, attachment)
  }
}, Map())

const attachmentUploadStateById = handleActions({
  [combineActions(
    actions.uploadAttachmentPending,
    actions.uploadAttachmentFailed,
  )]: (state, action) => {
    const { ticketId } = action.payload
    return state.set(ticketId, action.type)
  },
  [actions.uploadAttachmentSuccess]: (state, action) => {
    const { attachment, ticketId } = action.payload
    return state.set(ticketId, attachment)
  }
}, Map())

export default combineReducers({
  byId,
  attachmentUploadStateById
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/attachment/reducer.js